/* @flow strict */

/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */

import * as React from 'react';
import _ from 'lodash';
import DataTable from 'react-data-table-component';
import useOutsideClick from '../../../../utils/useOutsideClick';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { emailRegexp } from '../../../../constants';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { createDynamicColumn, getQuestion } from './questionsHelper';
import TableSkeleton from '/client/src/components/skeletons/dataTableSkeleton';
import { RouterPrompt } from '/client/src/components/routerPrompt';

type PropsType = {
  subViewTab?: string,
  counter: number,
  data: [],
  setRows: () => void,
  rowsOrg: {},
  setRowsOrg: () => void,
  rowsFilter: null | {},
  progressPending: boolean,
  showPaymentModal: boolean,
  handleShowPaymentModal: (boolean) => void,
  handleShowPaymentModalOrderId: (string | number) => void,
  showPaymentPurchaseModal: boolean,
  handleShowPaymentPurchaseModal: (boolean) => void,
  editRow: {} | null,
  toggleEdit: (number) => void,
  onHandleFindAndReplaceRowData: () => void,
  sponsors?: [],
  maxResultCount: number,
  setMaxResultCount: (number) => void,
  totalRows: number,
  handlePageChange: (number) => void,
  handleSort: (string) => void,
  currentPage: number
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  },
  tableWrapper: {
    style: {
      display: 'block',
      overflowX: 'scroll'
    }
  },
  table: {
    style: {
      display: 'table'
    }
  }
};

let mock = {
  columns: []
};

const EventPageDetailCustomersBody = ({
  subViewTab,
  counter,
  data,
  rowsOrg,
  setRowsOrg,
  progressPending,
  rowsFilter,
  showPaymentModal,
  handleShowPaymentModal,
  handleShowPaymentModalOrderId,
  showPaymentPurchaseModal,
  handleShowPaymentPurchaseModal,
  editRow,
  toggleEdit,
  onHandleFindAndReplaceRowData,
  sponsors,
  maxResultCount,
  setMaxResultCount,
  totalRows,
  handlePageChange,
  currentPage,
  handleSort
}: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const eventContext = React.useContext(EventDetailContainerContext);
  const [preSavedQuestionAnswers, setPreSavedQuestionAnswers] = React.useState([]);

  try {
    // eslint-disable-next-line
    mock = require(`./tableHeaders/${_.toString(subViewTab) === '' || !subViewTab ? 'tickets.js' : `${_.toString(subViewTab)}.js`}`);
  } catch (e) {
    console.warn(`File "./tableHeaders/${_.toString(subViewTab)}" doesn't exist`);
  }

  const isNeedShowConfirm = (editRow, rowsOrg): boolean => {
    if (!editRow) return true;

    if (subViewTab !== 'payments') {
      return editRow.first_name !== rowsOrg.first_name ||
      editRow.last_name !== rowsOrg.last_name ||
      editRow.email_address !== rowsOrg.email_address ||
      editRow.phone_number !== rowsOrg.phone_number ||
      editRow.remark !== rowsOrg.remark ||
      editRow.sponsor_name !== rowsOrg.sponsor_name ||
      editRow.sponsor_id !== rowsOrg.sponsor_id;
    }

    return editRow.customer_first_name !== rowsOrg.customer_first_name ||
    editRow.customer_last_name !== rowsOrg.customer_last_name ||
    editRow.customer_email_address !== rowsOrg.customer_email_address ||
    editRow.customer_phone_number !== rowsOrg.customer_phone_number ||
    editRow.sponsor_name !== rowsOrg.sponsor_name ||
    editRow.sponsor_id !== rowsOrg.sponsor_id;
  };

  const ref = React.useRef();

  const ValidateByEmpty = (): boolean | string => {
    if (!editRow) {
      return;
    }

    if (subViewTab !== 'payments') {
      if (!_.size(editRow.first_name) ||
        !_.size(editRow.last_name) ||
        !emailRegexp.test(editRow.email_address)
      ) {
        let msg = '';

        if (!_.size(editRow.first_name)) {
          msg = 'We seem to be missing a first name.';
        }

        if (!_.size(editRow.last_name)) {
          msg = 'We seem to be missing a last name.';
        }

        if (!emailRegexp.test(editRow.email_address)) {
          msg = 'We seem to be missing an email address.';
        }

        return msg;
      }

      return false;
    }

    if (!_.size(editRow.customer_first_name) ||
      !_.size(editRow.customer_last_name) ||
      !emailRegexp.test(editRow.customer_email_address)
    ) {
      let msg = '';

      if (!_.size(editRow.customer_first_name)) {
        msg = 'We seem to be missing a first name.';
      }

      if (!_.size(editRow.customer_last_name)) {
        msg = 'We seem to be missing a last name.';
      }

      if (!emailRegexp.test(editRow.customer_email_address)) {
        msg = 'We seem to be missing an email address.';
      }

      return msg;
    }

    return false;
  };

  const saveEditedRow = () => {
    $('.EventPageDetailCustomers .icon.icon-save').click();
    setTimeout(() => {
      toggleEdit(null);
    }, 500);
  };

  const cancelRowEdit = () => {
    if (subViewTab !== 'payments') {
      editRow.first_name = rowsOrg.first_name;
      editRow.last_name = rowsOrg.last_name;
      editRow.email_address = rowsOrg.email_address;
      editRow.phone_number = rowsOrg.phone_number;
      editRow.remark = rowsOrg.remark;
    } else {
      editRow.customer_first_name = rowsOrg.customer_first_name;
      editRow.customer_last_name = rowsOrg.customer_last_name;
      editRow.customer_email_address = rowsOrg.customer_email_address;
      editRow.customer_phone_number = rowsOrg.customer_phone_number;
    }

    editRow.sponsor_name = rowsOrg.sponsor_name;
    editRow.sponsor_id = rowsOrg.sponsor_id;

    toggleEdit(null);
  };

  useOutsideClick(ref, (target: any) => {
    if (!isNeedShowConfirm(editRow, rowsOrg)) {
      toggleEdit(null);
      setRowsOrg({});
    } else if (editRow && _.size(rowsOrg)) {
        const isValid = ValidateByEmpty();

        if (target.classList.contains('btn-pink')) {
          return;
        }

        if (_.isString(isValid)) {
          context.handleShowSystemDialog(true, {
            systemDialogType: 'error',
            systemDialogTitle: 'Oops',
            systemDialogContent: isValid
          });
        } else {
          context.handleShowSystemDialog(true, {
            systemDialogType: 'warning',
            systemDialogTitle: 'Hmmm...',
            systemDialogContent: 'There were some changes made, save?',
            systemDialogCallback: () => saveEditedRow(),
            systemDialogCancelCallback: () => cancelRowEdit()
          });
          setRowsOrg({});
        }
      }
  });

  const columns = mock.columns(
    rowsFilter,
    showPaymentModal,
    handleShowPaymentModal,
    handleShowPaymentModalOrderId,
    showPaymentPurchaseModal,
    handleShowPaymentPurchaseModal,
    editRow,
    rowsOrg,
    toggleEdit,
    onHandleFindAndReplaceRowData,
    sponsors,
    setRowsOrg,
    isNeedShowConfirm,
    ValidateByEmpty
  );

  if (subViewTab === 'questions') {
    const _questionsColumns = [];

    _.map(eventContext.eventDetail.questions, (q: {}) => {
      const col = createDynamicColumn(
        eventContext.eventDetail.questions,
        _questionsColumns,
        q.id,
        q.text,
        editRow,
        rowsOrg,
        toggleEdit,
        setRowsOrg,
        isNeedShowConfirm,
        onHandleFindAndReplaceRowData,
        ValidateByEmpty,
        preSavedQuestionAnswers,
        setPreSavedQuestionAnswers
        );

      _questionsColumns.push(col);
    });

    const _uniq = _.uniqBy(_questionsColumns, 'selector');

    columns.push(..._uniq);
  }
  const getDefaultSortString = (): string => {
    if (subViewTab === 'questions') {
      return 'first_name';
    }
    if (subViewTab === 'demographics') {
      return 'last_name+desc';
    }
    return 'order.paid_time_utc';
  };
  const handleTableSort = (selector, sortDirection): string => {
    let sortStr = '';

    if (selector === 'birth_year') {
      sortStr =  `birth_day+${sortDirection},birth_month+${sortDirection},birth_year+${sortDirection}`;
    } else {
      sortStr = `${selector}+${sortDirection}`;
    }

    handleSort(sortStr);
  };

  return (
    <>
    <RouterPrompt
      when={!!editRow}
      title="There were some changes made, save?"
      onOK={() => saveEditedRow()}
      onCancel={() => cancelRowEdit()}
    />
    <div className="panel-body" data-reload={counter}>
      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }} ref={ref}>
          <DataTable
            className={
              _.toString(subViewTab) === '' || _.toString(subViewTab) === 'tickets' || _.toString(subViewTab) === 'payments' ?
                'EventPageDetailCustomers-Tickets-Payments' :
                'EventPageDetailCustomers'}
            columns={columns}
            defaultSortField={getDefaultSortString()}
            defaultSortAsc={false}
            data={data}
            customStyles={customStyles}
            sortServer
            onSort={(column, sortDirection) => handleTableSort(column.selector, sortDirection)}
            highlightOnHover
            pointerOnHover
            pagination
            paginationPerPage={maxResultCount}
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            paginationRowsPerPageOptions={[100, 500, 1000]}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={setMaxResultCount}
            responsive
            striped
            fixedHeader
            noHeader
            persistTableHead
            progressPending={progressPending}
            progressComponent={<TableSkeleton rows={maxResultCount} columns={columns} />}
            sortIcon={(): React.Element<typeof React.Fragment> => {
              return (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
    </>
  );
};

export default EventPageDetailCustomersBody;
